.tag-group {
  display: flex;
  flex-wrap: wrap; /* wraps to next line if too many */
  gap: 8px;
  align-items: center;
  width: 100%;
}

.tag-group__add-container {
  margin-right: 5px;

  button.tag-group__add-tag {
    width: 24px;
    height: 24px;
    padding: 0;

    .material-icons {
      display: flex;
      font-size: 16px;
    }
  }
}

.tag-group__show-more-container {
  display: inline-flex;
  align-items: center;

  .button {
    color: var(--color-text-primary);
    min-height: 22px;
  }

  .no-padding {
    padding: 0;
  }
}

.tag-group__input {
  border: none;
  background: transparent;
  outline: none;
  font: inherit;
  color: inherit;
  padding: 0;
  width: 140px;
}
